import PropTypes from 'prop-types';

export const Props = {
  /**
   * Optional id to assign to the element
   */
  id: PropTypes.string,
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
